<template>
    <div :class="'help ' + horizontal">
        <a :href="url" target="_blank"><img src="/img/Help.png" alt="Auggie Help"></a>
    </div>
</template>

// Help Icon : https://iconarchive.com/show/elementary-icons-by-danrabbit/Button-help-icon.html
// License: GNU GPL

<style scoped lang="scss">
    .help {
        position: absolute;
        left:0;
        top:0;
        img {
            width: 48px;
            height: 48px;
        }
    }
</style>

<script lang="ts">

import { defineComponent } from "vue";

export default defineComponent({
    props: {
        horizontal: { type: String, required: false, default: "left" },
    },
    data() {
        return {
            url: "https://airprodiagnostics.com/auggie-frequently-asked-questions/",
        };
    },
});

</script>
